module.exports = __webpack_public_path__ + "img/background22 (2).0535ad41.jpg";